<div class="row">
  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="basemapSelect">background</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <select [(ngModel)]="basemap"
              id="basemapSelect"
              (ngModelChange)="basemapChanged()"
              class="form-control form-control-sm">
        <option *ngFor="let bl of basemaps" [ngValue]="bl">{{bl.name}}</option>
      </select>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="vector-selection">boundaries</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <vector-layer-selection [vectorLayers]="vectorLayers"
                              [currentZoom]="zoom"
                              [vectorLayer]="vectorLayer"
                              (vectorLayerSelected)="vectorLayerChanged($event)">
      </vector-layer-selection>
                              <!-- [enabled]="mapConfig.showVectors" -->
    </div>
  </div>

  <div>
    <app-opacity-slider [opacity]="opacity"
                        (opacityChange)="settingControlChanged($event)"></app-opacity-slider>
  </div>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="vector-selection">legend</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <div class="form-check form-switch form-switch-md">
        <input type="checkbox"
              class="form-check-input"
              id="legendSwitch"
              [(ngModel)]="showLegend"
              (ngModelChange)="showLegendChanged()">
        </div>
    </div>
  </div>

  <div class="row form-group">
    <div class="col-xl-12 col-xxl-4">
      <label for="vector-selection">scale</label>
    </div>
    <div class="col-xl-12 col-xxl-8">
      <div class="form-check form-switch form-switch-md">
        <input type="checkbox"
             class="form-check-input"
             id="scaleSwitch"
             [(ngModel)]="showScale"
             (ngModelChange)="showScaleChanged()">
        </div>
    </div>
  </div>

  <div class="col-12">
    <span class="float-end">
      <button class="btn btn-secondary btn-sm"
              (click)="closePanel()">
        Close
      </button>
    </span>
  </div>

</div>
